import { withAuthenticationRequired } from '@auth0/auth0-react';
import GroupManagement from '../group_management/GroupManagement';
import { useOrganizationUpdaterProvider } from '../../../context_providers/organization_context/OrganizationProvider';
import Loading from '../../../components/loading/Loading';
import LoadingSpinner from '../../../components/loading/LoadingSpinner';
import { useLoading } from '../../../context_providers/loading_context/LoadingContext';
import { useEffect, useState } from 'react';

export const UserManagement = () => {
  const [loading, setLoading] = useState(true);
  const { organization } = useOrganizationUpdaterProvider();
  const { setPageLoading } = useLoading();

  useEffect(() => {
    if (organization) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setLoading(false);
      setPageLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization]);

  return (
    <>
      {!loading ? (
        <GroupManagement />
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
};

export default withAuthenticationRequired(UserManagement, {
  onRedirecting: () => <Loading loadingText={'Loading...'} />,
});
